import { Component, Input, OnInit, ChangeDetectionStrategy, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-cr-avatar',
  templateUrl: './cr-avatar.component.html',
  styleUrls: ['./cr-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CrAvatarComponent implements OnInit, OnChanges {
  @Input() userName: string = '';
  @Input() theme: 'THEME-1' | 'THEME-2' = 'THEME-1';
  @Input() size: 'S' | 'M' | 'L' = 'S';

  public initials: string = '';
  public sizeClass = 'size-s';
  public themeClass = 'theme-1';

  ngOnInit(): void {
    this.updateViewModel();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userName'] || changes['size'] || changes['theme']) {
      this.updateViewModel();
    }
  }

  private updateViewModel(): void {
    this.initials = this.getInitials(this.userName);
    this.sizeClass = this.getSizeClass(this.size);
    this.themeClass = this.theme === 'THEME-1' ? 'theme-1' : 'theme-2';
  }

  private getSizeClass(size: 'S' | 'M' | 'L'): string {
    const sizeNominator = size || 'S';
    return `size-${sizeNominator.toLowerCase()}`;
  }

  private getInitials(name: string): string {
    if (!name || name.trim().length === 0) {
      return '';
    }

    const trimmedName = name.trim();
    const words = trimmedName.split(' ').filter(word => word.length > 0);

    if (words.length === 0) {
      return '';
    }

    if (words.length === 1) {
      // Single word - take first and last letter
      const word = words[0];
      const firstLetter = word.charAt(0).toUpperCase();
      const lastLetter = word.charAt(word.length - 1).toUpperCase();
      return firstLetter + lastLetter;
    }

    // Multiple words - take first letter of first and last word
    const firstInitial = words[0].charAt(0).toUpperCase();
    const lastInitial = words[words.length - 1].charAt(0).toUpperCase();

    return firstInitial + lastInitial;
  }
}
